module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#arrow",
      toString: function () {
        return this.url;
      }
    }